import { Directive, ElementRef, OnDestroy, OnInit, inject, input } from '@angular/core';

import { ItemCartMediatorDirective } from './item-cart-mediator.directive';

@Directive({ standalone: true, selector: '[itemCartTarget]' })
export class ItemCartTargetDirective implements OnInit, OnDestroy {
  private element = inject(ElementRef);
  private readonly host = inject(ItemCartMediatorDirective);

  public readonly itemCartTargetId = input<string>(undefined);

  public ngOnDestroy(): void {
    this.host.deregister(this.itemCartTargetId());
  }

  public ngOnInit(): void {
    this.host.register(this.itemCartTargetId(), this.element);
  }
}
